export default __webpack_public_path__ + "components/weather-icon/static/daycloud-6e0b876e92653c900192b15a2387dccb.webp";